import _ from 'lodash';
import React from 'react';
import autobind from 'autobind-decorator';
import { observe } from 'mobx';
import { inject, observer } from 'mobx-react';

import Pagination from 'common/components/pagination';
import DeleteButton from 'common/components/delete-button';

@inject('userStore')
class ImageRow extends React.Component {
	render () {
		const { user: { _id, profileImage, firstName, lastName } } = this.props;

		return (
			<div className="cell small-12 medium-4 large-3">
				<div className="grid-x align-middle">
					<div className="cell small-12">
						<div
							className="image medium"
							style={{
								margin: '0 auto',
								backgroundImage: `url('/assets/public/s3/img/${profileImage}')`
							}}
						></div>
					</div>

					<div className="cell shrink text-center">
						<DeleteButton
							orientation="right"
							warningText={ `Really delete profile image?` }
							onConfirmClick={ this.onConfirmClick }
						>
							<button className="button alert clear">
								<span className="fas fa-trash"></span>
							</button>
						</DeleteButton>
					</div>

					<div className="cell auto">
						<p className="margin-left-1 margin-right-1 truncate-text">{ `${firstName} ${lastName}` }</p>
					</div>
				</div>
			</div>
		);
	}

	@autobind
	onConfirmClick () {
		const { userStore, user } = this.props;
		userStore.removeProfileImage(user);
	}
}

@inject('userStore')
@observer
class ManageImages extends React.Component {
	constructor (props) {
		super(props);

		const { userStore } = this.props;

		if (_.isEmpty(userStore.pagination)) {

			userStore.fetchPagedItems();
		}
	}

	render () {
		return (
			<div className="grid-x grid-padding-x" onClick={ this.onClick }>
				<div className="cell small-12">
					<div className="grid-x align-bottom">
						<div className="cell small-12 padding-left-1 padding-top-1">
							<h3>Manage Images</h3>
						</div>
					</div>

					<Pagination store={ this.props.userStore } />

					{ this.renderMainContent() }
				</div>
			</div>
		);
	}

	renderMainContent () {
		const { userStore } = this.props;

		if (userStore.arePagesLoading) {

			return (
				<div className="loading-spinner large"></div>
			);
		}

		return (
			<div className="grid-x grid-padding-x manage-images-list-container">
				{
					(userStore
						.pagination
						.items || [])
						.map((user) => <ImageRow key={ user._id } user={ user } />)
				}
			</div>
		);
	}
}

export default ManageImages;
